// src/payment.ts
function getDirectusFileId(ref) {
  if (!ref) return null;
  if (typeof ref === "string") return ref;
  return ref.id ?? null;
}

export { getDirectusFileId };
//# sourceMappingURL=payment.js.map
//# sourceMappingURL=payment.js.map